import { useEffect } from 'react';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';

const DOCUMENT_NOT_FOUND_MESSAGE =
  "We couldn't find this document. It might have been deleted or you might not have access.";

interface UseErrorFeedbackProps {
  error: boolean;
  documentId: string;
}

/**
 * Shows feedback when a document query succeeds without finding a document.
 */
export function useErrorFeedback({ error, documentId }: UseErrorFeedbackProps) {
  const { showFeedback } = useFeedback();

  useEffect(() => {
    if (error) {
      showFeedback(DOCUMENT_NOT_FOUND_MESSAGE);
    }
  }, [documentId, error, showFeedback]);
}
